import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import AvailabilityCard from "./AvailabilityCard";

// El terapeuta conectado edita su propio horario de citas
export default function MySchedulePage() {
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  if (!user?.isTherapist) {
    return <p>Solo los terapeutas tienen horario de citas.</p>;
  }
  return <AvailabilityCard therapistId={user._id} />;
}
